import { render } from "./PedidoView.vue?vue&type=template&id=64b58814&scoped=true"
import script from "./PedidoView.vue?vue&type=script&lang=js"
export * from "./PedidoView.vue?vue&type=script&lang=js"

import "./PedidoView.vue?vue&type=style&index=0&id=64b58814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b58814"]])

export default __exports__